import { axiosSwagger } from "@/axios";

export const state = {
    approved: {
        loading: false,
        data: [],
        total: 0,
    }

}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.approved.loading = loading;
    },
    setData: (state, data) => {
        state.approved.data = modifyData( data );
    },
    setTotal: (state, total) => {
        state.approved.total = total;
    },
    remove: (state, id) => {
        state.approved.data = state.approved.data.filter((el) => el.id !== id);
    },
}


export const actions = {
    // FILE APPROVED
    async readApprovedPost({ commit }) {
        commit("loading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FilePosting/Approved/DeliveryUnitId/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    // eslint-disable-next-line no-unused-vars
    async updatePostedToPendingFilePost({ commit }, id) {
        return await axiosSwagger
        .put(`/api/FilePosting/Post/${id}`)
        .then((response) => {
            commit('remove', id);

            return response;
        });
    },
}

const checkIsClassified = (e) => {
    if(e ?? false){
      // e filter data if classified and if user is not the one who upload
      const isClassified = e?.isClassified || false;
      const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
      
      return isClassified && e?.applicationUserId !== userData?.userId;
    }
}

// eslint-disable-next-line no-unused-vars
const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
      arrayData.forEach(e => {
        // modify data for post pool files
        e.postPoolFiles = [];

        const isClassifiedDoc = checkIsClassified(e);

        e.isClassifiedDoc = isClassifiedDoc;
        e.fileManager.isClassifiedDoc = isClassifiedDoc;
      });
  
      return arrayData;
    }
  
    return [];
};
  